var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "blockWrapper",
      class: [
        "buttons-bottom-header__item _with-popup",
        { "_with-popup--active": _vm.isShowPopup },
      ],
      attrs: { "data-list-type": "jsCart" },
    },
    [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__link",
          attrs: { href: "/personal/cart/" },
        },
        [
          _c("div", { staticClass: "buttons-bottom-header__icon" }, [
            _c(
              "svg",
              {
                attrs: {
                  width: "19",
                  height: "20",
                  viewBox: "0 0 19 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg",
                },
              },
              [
                _c("path", {
                  attrs: {
                    "fill-rule": "evenodd",
                    "clip-rule": "evenodd",
                    d: "M6.90117 4.5C7.31301 3.33481 8.42425 2.5 9.73047 2.5C11.0367 2.5 12.1479 3.33481 12.5598 4.5H6.90117ZM4.83049 4.5C5.29376 2.21776 7.31151 0.5 9.73047 0.5C12.1494 0.5 14.1672 2.21776 14.6305 4.5H15.8594C16.9123 4.5 17.7849 5.31637 17.8549 6.36696L18.7305 19.5H0.730469L1.606 6.36696C1.67604 5.31637 2.54865 4.5 3.60157 4.5H4.83049ZM2.86824 17.5L3.60157 6.5H15.8594L16.5927 17.5H2.86824Z",
                    fill: "#474747",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "items-count", staticStyle: { display: "none" } },
              [_vm._v("1")]
            ),
            _vm._v(" "),
            _vm.countItems > 0
              ? _c(
                  "div",
                  {
                    staticClass:
                      "buttons-bottom-header__icon-count items-count__show",
                  },
                  [_vm._v("\n        " + _vm._s(_vm.countItems) + "\n      ")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("Корзина")]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons-bottom-header__item-popup" }, [
        _c(
          "div",
          { staticClass: "buttons-bottom-header__added-products jsCart" },
          [
            _vm._l(_vm.items, function (item, key) {
              return [
                _c("header-product", {
                  key: "header-basket-product-" + key,
                  attrs: { item: item },
                  on: { deleteItem: _vm.deleteItem },
                }),
              ]
            }),
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "buttons-bottom-header__btn-wrapper" }, [
      _c(
        "a",
        {
          staticClass: "buttons-bottom-header__btn _btn",
          attrs: { href: "/personal/cart/" },
        },
        [_c("p", [_vm._v("Перейти в корзину")]), _vm._v(" "), _c("span")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }